module.exports = __webpack_public_path__ + "assets/phone-c7b21626fbc7e9a9a9bee6725a6dfb88.jpg";


//////////////////
// WEBPACK FOOTER
// ./pages/Contact/assets/phone.jpg
// module id = 631
// module chunks = 0 1